<template>
    <div class="restaurant">
      <div class="container">
        <div class="row"> <!-- Titulo -->
          <h2 class="title">Tranquilândia {{$t('telas.restaurante.titulo')}}</h2>
        </div>

        <div class="row">
          <div class="col-md-6 col-lg-6">
            <slider v-if="!errorSlider" :item="images" :radius="true" style="box-shadow:3px 3px 3px #888"></slider>
            <img v-else src="../../assets/img/restaurante/1.jpg" id="imgError" alt="">
          </div>

          <div class="col-md-6 col-lg-6">
            <p class="restaurant-text">
              {{$t('telas.restaurante.descricao.resumo')}}
              <br>
            </p>

            <h4 class="restaurant-title-table">{{$t('telas.restaurante.descricao.horario_funcionamento')}}</h4>
            <table class="table table-striped">
              <tbody>
                <tr>
                  <th scope="row">{{$t('telas.restaurante.descricao.dias')}}</th>
                  <td>{{$t('telas.restaurante.descricao.descricao_dias')}}</td>
                </tr>
                <tr>
                  <th rowspan="2" style="padding-top:7%">{{$t('telas.restaurante.descricao.horario')}}</th>
                  <td>{{$t('telas.restaurante.descricao.abre')}}: 12:00PM</td>
                </tr>
                <tr>
                  <td>{{$t('telas.restaurante.descricao.fecha')}}: 16:00PM</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>

        <reserva :header="true"></reserva>

      </div> <!-- container -->

    </div>
</template>

<script>
import reserva from '../../components/reservation-component/ReservationComponent'
import slider from '../../components/slider/Slider'
import { urlBase } from '../../../config/url'

export default {
  name: 'Restaurant',

  data() {
    return {
      images: {
        id: '1',
        imagesUrl: [],
        slideError: false
      }
    }
  },

  components: {
    reserva,
    slider
  },

  created() {
    this.slideError = false
    
    try {
      for(let i = 1; i <= 16; i++) {
        this.images.imagesUrl.push(require(`@/assets/img/restaurante/${i}.jpg`))
      }
    } catch(err) {
      this.slideError = true
      console.error(err)
    }
  },

  computed: {
    errorSlider() {
      return this.slideError
    }
  }
}
</script>

<style>
.restaurant {
  background-color: white;
  color: white;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
  padding-top: 100px;
}
.restaurant .container .row h2.title {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
  margin-bottom: 40px;
}
.restaurant #imgError {
  width: 100%;
  border-radius:5px;
  box-shadow: 3px 3px 3px #888;
}

.restaurant .container .row h4.restaurant-title-table {
  text-align: center;
  color: #444;
}
.restaurant .container .row p.restaurant-text {
  text-align: justify;
  color: black;
}
.restaurant .container .row table th,
.restaurant .container .row table td {
  color: black
}

.restaurant .container .row .container-flex div#carrousel-restaurante img {
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/restaurant/Restaurant.vue